import DashboardLayout from "../../layouts/DashboardLayout";
import ProtectedRoute from "../../components/common/ProtectedRoute";

const AuthLayout = ({ children }) => {
  return (
    <ProtectedRoute>
      <DashboardLayout>{children}</DashboardLayout>
    </ProtectedRoute>
  );
};

export default AuthLayout;
